import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, array, boolean, object, string } from "yup";
import "Forms/Schemas/customMethods";

export type LifestyleExpenseFormType = {
  readonly aggregatedAmount?: string;
  readonly detailed?: boolean;
  readonly vacation?: string;
  readonly vacationName?: string;
  readonly hobbies?: string;
  readonly hobbiesName?: string;
  readonly entertainment?: string;
  readonly entertainmentName?: string;
  readonly sport?: string;
  readonly sportName?: string;
  readonly health?: string;
  readonly healthName?: string;
  readonly customItems?: { name?: string; value?: string }[];
};

export const getLifestyleExpenseFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<LifestyleExpenseFormType> = (t) => {
  const customItemSchema = object({
    name: string().required(t(Resources.Validation.Required)),
    value: string()
      .required(t(Resources.Validation.Required))
      .greaterThanZero(t(Resources.Validation.Number.MoreThen, { count: 0 })),
  });

  return object({
    detailed: boolean().optional(),
    aggregatedAmount: string().when(["detailed"], ([detailed], schema) =>
      !detailed
        ? schema.required(t(Resources.Validation.Required)).greaterThanZero(t(Resources.Validation.Number.MoreThen, { count: 0 }))
        : schema.optional(),
    ),
    vacation: string().optional(),
    vacationName: string().optional(),
    hobbies: string().optional(),
    hobbiesName: string().optional(),
    entertainment: string().optional(),
    entertainmentName: string().optional(),
    sport: string().optional(),
    sportName: string().optional(),
    health: string().optional(),
    healthName: string().optional(),
    customItems: array().when(["detailed"], ([detailed], schema) => {
      return detailed ? schema.of(customItemSchema).optional() : schema.optional().nullable();
    }),
  }).defined();
};
